import { useTheme } from '@/services/theme';
import { curators } from '@/features/vaults/curators';
import { Flex } from '@/shared/components/Flex';
import { CuratorIcon } from '@/shared/components/CuratorIcon';
import { Typography } from '@/shared/components/Typography';
import { CuratorLink } from '@/shared/components/WhiteLabelTitleHeaders/ui/CuratorLink';
import { CuratorID } from '@/features/vaults/types/CuratorID';

type WhiteLabelPoweredByProps = {
  curatorId: CuratorID;
};

export const WhiteLabelPoweredBy = ({ curatorId }: WhiteLabelPoweredByProps) => {
  const { theme } = useTheme();

  const curatorHref = curators[curatorId]?.href;
  const curatorIcon = (
    <Flex
      align="center"
      justify="center"
      padding="10px"
      height="34px"
      borderRadius="8px"
      background={theme.colors.primary}
    >
      <CuratorIcon curatorId={curatorId} />
    </Flex>
  );

  return (
    <Flex direction="row" gap="10px" align="center">
      <Typography
        color="secondary"
        fontFamily="gramatika"
        size="14px"
        weight={700}
        variant="body1"
        lineHeight="15px"
        letterSpacing="0.05em"
      >
        POWERED BY
      </Typography>

      {curatorHref ? (
        <CuratorLink to={curatorHref} target="_blank">
          {curatorIcon}
        </CuratorLink>
      ) : (
        curatorIcon
      )}
    </Flex>
  );
};
